import { api } from '../../lib/api';

const state = {
  experts: [],
};

const getters = {
  experts: st => st.experts,
};

const mutations = {
  setExperts(state, experts) {
    state.experts = experts;
  },
};

const actions = {
  async fetchExperts({ commit }) {
    try {
      const response = await api.get('api/users');
      commit('setExperts', response.data['hydra:member']);
    } catch (error) {}
  },
};

export default { namespaced: true, actions, state, mutations, getters };
